import { Navigate } from 'react-router';
import { v4 } from 'uuid';

export const NFCRedirect = () => {
  const id = v4();
  window.localStorage.setItem('nfc-etag', id);
  return <Navigate to="/nfc" replace={true} state={{ id }} />;
};
